const AddonRelationshipForParentAndChild = [
  { relatesFromEntitlementsRelationshipType: 'ADDON_DEPENDENCE' },
  { relatesToEntitlementsRelationshipType: 'ADDON_DEPENDENCE' },
];
export const commonEntitlementQueryFilters = (
  isFreeEnabled = false,
  showInactiveProducts = false,
  showAddonProducts = false
) => {
  if (!isFreeEnabled) {
    return [
      {
        key: 'status',
        value: 'Active',
      },
      {
        key: 'billingFrequency',
        value: 'Monthly',
      },
      {
        key: 'or',
        value: JSON.stringify([
          { isNotNull: 'cloudSiteId' },
          { isNotNull: 'organisationId' },
          ...AddonRelationshipForParentAndChild,
        ]),
      },
    ];
  }

  if (isFreeEnabled && showInactiveProducts && !showAddonProducts) {
    return [
      {
        key: 'or',
        value: '[{"isNotNull":"cloudSiteId"},{"isNotNull":"organisationId"}]',
      },
      {
        key: 'not',
        value: JSON.stringify([{ edition: 'Beta' }, ...AddonRelationshipForParentAndChild]),
      },
    ];
  }
  if (isFreeEnabled && showInactiveProducts && showAddonProducts) {
    return [
      {
        key: 'or',
        value: '[{"isNotNull":"cloudSiteId"},{"isNotNull":"organisationId"}]',
      },
      {
        key: 'not',
        value: '[{"edition":"Beta"}]',
      },
    ];
  }
  if (isFreeEnabled) {
    return [
      {
        key: 'status',
        value: 'Active',
      },
      {
        key: 'or',
        value: '[{"billingFrequency":"Monthly"},{"isNull":"billingFrequency"}]',
      },
      {
        key: 'or',
        value: '[{"isNotNull":"cloudSiteId"},{"isNotNull":"organisationId"}]',
      },
      {
        key: 'not',
        value: JSON.stringify([{ edition: 'Beta' }, ...AddonRelationshipForParentAndChild]),
      },
    ];
  }
};
